(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5843],{

/***/ 4992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ singleSliderSettings; }
});

// UNUSED EXPORTS: doubleFeatureContentCardSettings

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Default/CarouselSlick/v1/Arrow.jsx

const Arrow = (props)=>{
    const { className ="" , style ="" , onClick =()=>{} , label ="" , topPosition =0 , addAnalyticsForArrows =()=>{}  } = props;
    const clickHandler = (e, label)=>{
        onClick && onClick(e);
        addAnalyticsForArrows(label);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: className,
        type: "button",
        "aria-label": label,
        style: {
            ...style,
            top: topPosition ? topPosition : ""
        },
        onClick: (e)=>clickHandler(e, label)
    });
};
/* harmony default export */ var v1_Arrow = (Arrow);

;// CONCATENATED MODULE: ./src/components/Default/CarouselSlick/v1/SlickSettings.js


const doubleFeatureContentCardSettings = {
    dots: false,
    infinite: true,
    fade: true,
    autoplay: false,
    cssEase: "ease-in-out",
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false
};
const singleSliderSettings = function(cb, topPosition, autoplay, autoplaySpeed, addAnalyticsForArrows) {
    let afterChangeCb = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : ()=>{};
    return {
        autoplay,
        autoplaySpeed,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: true,
        centerMode: false,
        beforeChange: (_, current)=>cb ? cb(current + 1, current) : undefined,
        afterChange: (a, b)=>afterChangeCb ? afterChangeCb(a, b) : undefined,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Next",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Previous",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        })
    };
};


/***/ }),

/***/ 47010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82476);
/* harmony import */ var _components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85721);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18216);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25935);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20558);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85518);
/* harmony import */ var _components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45138);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_Default_CarouselSlick_v1_SlickSettings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4992);
/* harmony import */ var _components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59998);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55511);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27514);
/* harmony import */ var _components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75179);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97217);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19514);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(72337);



















const UpSellInstallServicesCarousalSlick = (param)=>{
    let { upSellData =[] , authData ={} , handleAddToCart =()=>{} , slickRef , addServiceToCart =()=>{} , isSearchClick =""  } = param;
    const { upSellServiceData: { productTitleUpSell ="" , serviceAvailableTitleUpSell ="" , serviceAvailableDescUpsell ="" , toolTipsUpSell ="" , learnAboutUpSell ="" , priceGuardUpSell ="" , toolTipsDescUpSell ="" , outOfStockTitle ="" , includeTitle ="" , recommendationTitle ="" , selectedTitle ="" , presetConfigsUpSellProduct: productPresetConfigs = {} , swatchUrlUpSell: baseUrlImage = ""  } = {}  } = authData;
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__/* .getUserPersona */ .shu)();
    const [tooltip, setTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        buyMoreSaveMore: false
    });
    const [includedItems, setIncludedItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [brandName, setBrandName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kohler");
    const [skuPrependName, setSkuPrependName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const rowCols = (0,_utils_index__WEBPACK_IMPORTED_MODULE_7__/* .getRowCols */ .n)(width, react_device_detect__WEBPACK_IMPORTED_MODULE_8__/* .isMobile */ .tq, react_device_detect__WEBPACK_IMPORTED_MODULE_8__/* .isTablet */ .Em);
    let arrowLabel = "Next";
    const slickSettings = (0,_components_Default_CarouselSlick_v1_SlickSettings__WEBPACK_IMPORTED_MODULE_11__/* .singleSliderSettings */ .N)((_, current)=>{}, 0, false, 500, (label)=>{
        arrowLabel = label;
    }, (currentIndexAfterChange)=>{
        const currentSlideServiceData = upSellData[eval(currentIndexAfterChange)];
        if (!isSearchClick) {
            (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForArrows */ .X1)(arrowLabel, currentSlideServiceData, currentIndexAfterChange, persona, serviceAvailableTitleUpSell, recommendationTitle);
        }
    });
    slickSettings["infinite"] = false;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        callToConfiguration();
        makeDefaultSelection();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (upSellData.length) {
            makeDefaultSelection();
        }
    }, [
        upSellData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        checkSkuKPrepend();
    }, []);
    const makeDefaultSelection = ()=>{
        const includedRequiredItems = {};
        upSellData.forEach((item)=>{
            const { installServiceData: { discountedPrice =0 , price =0 , skuId: serviceSkuId = ""  } = {} , cartProductData: { sku: parentSku = "" , quantity =1  } = {} , requiredItems =[]  } = item;
            includedRequiredItems[parentSku] = {
                subTotal: getSubTotal(requiredItems, parentSku) + (discountedPrice || price) * quantity,
                includedItems: {
                    ...requiredItems.reduce((obj, cur)=>{
                        var ref;
                        return {
                            ...obj,
                            [cur.sku_s]: {
                                check: cur.availableQuantity > 0,
                                quantity: 1,
                                availableQuantity: cur.availableQuantity,
                                productcategory: cur.Product_Category,
                                productname: cur.ProductBrandName_s || cur.ProductDescriptionProductShort_s,
                                project_img: (ref = cur.productImages) === null || ref === void 0 ? void 0 : ref.labelWithUrl_ss[0],
                                product_decs: cur.ProductDescriptionProductShort_s
                            }
                        };
                    }, {})
                },
                serviceCheckStatus: !!serviceSkuId,
                serviceQty: quantity
            };
        });
        setIncludedItems(includedRequiredItems);
    };
    const callToConfiguration = async ()=>{
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_17__/* .getConfig */ .i)();
        const { general: { siteName ="kohler"  } = {}  } = config !== null && config !== void 0 ? config : {};
        setBrandName(siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase());
    };
    const checkSkuKPrepend = async ()=>{
        var ref;
        const { apiEndPointData: { skuPrepend =""  } = {}  } = (ref = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_17__/* .getConfig */ .i)()) !== null && ref !== void 0 ? ref : {};
        setSkuPrependName(skuPrepend);
    };
    const getSubTotal = function() {
        let requiredItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", qty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        return requiredItems.reduce((n, param)=>{
            let { ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , sku_s: sku = "" , availableQuantity =0  } = param;
            var ref;
            let quantity = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) ? (ref = availableParentSku.includedItems[sku]) === null || ref === void 0 ? void 0 : ref.quantity : 1;
            skuId && sku === skuId ? quantity = qty : quantity;
            const price = availableQuantity ? discountedPrice || productPrice : 0;
            return n + price * quantity;
        }, 0);
    };
    const checkChangeHandlerForService = function(e) {
        let parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, installServiceData = arguments.length > 3 ? arguments[3] : void 0;
        const { target: { checked =false  } = {}  } = e;
        handleServiceOperations(checked, parentSku, index);
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForIncludeforInstallservice */ .Yl)(checked, includeTitle, recommendationTitle, installServiceData, index);
    };
    const handleServiceOperations = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, qty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, handleQtyChange = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            var _installServiceData;
            const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
            const { discountedPrice =0 , price =0  } = serviceData;
            let servicePrice = availableParentSku.serviceCheckStatus ? (discountedPrice || price) * qty : 0;
            if (handleQtyChange) {
                if (availableParentSku.serviceCheckStatus) {
                    var ref, ref;
                    const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                        var ref;
                        return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
                    });
                    if ((ref = upSellData[index]) === null || ref === void 0 ? void 0 : (ref = ref.requiredItems) === null || ref === void 0 ? void 0 : ref.length) {
                        const requiredFilteredItems = upSellData[index].requiredItems.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
                        const total = getSubTotal(requiredFilteredItems, parentSku) + servicePrice;
                        availableParentSku.subTotal = total;
                    }
                }
                availableParentSku.serviceQty = qty;
            } else {
                const operand = checked ? "+" : "-";
                availableParentSku.serviceCheckStatus = checked;
                const serviceQty = availableParentSku.serviceQty;
                servicePrice = (discountedPrice || price) * serviceQty;
                const { subTotal =0  } = availableParentSku;
                availableParentSku.subTotal = eval(subTotal + operand + servicePrice);
            }
            setIncludedItems(addedItems);
        }
    };
    const checkChangeHandlerForReqItems = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku)) {
            availableParentSku.includedItems[skuId].check = checked;
            if (index > -1) {
                const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                    var ref;
                    return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
                });
                const requiredFilteredItems = upSellData[index].requiredItems.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
                var _installServiceData;
                const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
                const { discountedPrice =0 , price =0  } = serviceData;
                const servicePrice = availableParentSku.serviceCheckStatus ? (discountedPrice || price) * (availableParentSku.serviceQty || 1) : 0;
                availableParentSku.subTotal = getSubTotal(requiredFilteredItems, parentSku) + servicePrice;
            }
            setIncludedItems(addedItems);
        }
    };
    const handleChange = function() {
        let qty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, action = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, installServiceData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, item = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
        if (parentSku && index > -1) {
            handleServiceOperations(true, parentSku, index, qty, true);
            (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForQuantitySelectorforinstallservice */ .Go)(index, action, installServiceData, item, qty);
        }
    };
    const quantityChangeHanlder = function() {
        let qty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, action = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, requiredItemsProductdata = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, childindex = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : -1, installServiceDataAvailable = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", cartProductData = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                var ref;
                return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
            });
            const requiredFilteredItems = upSellData[index].requiredItems.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
            availableParentSku.includedItems[skuId].quantity = qty;
            var _installServiceData;
            const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
            const { discountedPrice =0 , price =0  } = serviceData;
            const servicePrice = availableParentSku.serviceCheckStatus ? discountedPrice || price : 0;
            const total = getSubTotal(requiredFilteredItems, parentSku, skuId, qty) + servicePrice;
            availableParentSku.subTotal = total;
            setIncludedItems(addedItems);
            (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForQuantitySelectorforRequiredproduct */ .uK)(action, requiredItemsProductdata, index, installServiceDataAvailable ? childindex + 1 : childindex, persona, qty, cartProductData, installServiceDataAvailable);
        }
    };
    const handleFieldInfoMouseOver = function() {
        let tooltipFor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "buyMoreSaveMore", value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setTooltip({
            ...tooltip,
            [tooltipFor]: value
        });
    };
    const addTocarthandler = function(item, index, parentSku, serviceName, title, cartProductData, mainTitle, upSellDataIndex) {
        let installServiceData = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
        const isChildren = true;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        let qty = 1;
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            qty = availableParentSku.serviceQty;
        }
        const isCartAction = true;
        handleAddToCart(item, qty);
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, title, "", cartProductData, mainTitle, upSellDataIndex, 1, isChildren, item, qty, isCartAction);
    };
    const installserviceClickHandler = function(e, serviceName, cartProductData) {
        let upSellDataIndex = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", item = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
        const isChildren = true;
        const { target: { href ="" , textContent =""  } = {}  } = e;
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, textContent.toLowerCase(), href, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, isChildren, item);
    };
    const priceGuardClickHandler = function(e, serviceName, cartProductData) {
        let title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", upSellDataIndex = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", item = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
        const isChildren = true;
        const { target: { href ="" , textContent =""  } = {}  } = e;
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName.toLowerCase(), textContent.toLowerCase(), href, cartProductData, title, upSellDataIndex, 1, isChildren, item);
    };
    const addSelectedItem = function() {
        let parentSku = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, subTotal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        if (!parentSku) return;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            const requiredItems = availableParentSku.includedItems;
            const selectedItems = Object.keys(requiredItems).filter((key)=>requiredItems[key].check).map((item)=>{
                var ref;
                return {
                    sku: item,
                    quantity: (ref = requiredItems[item]) === null || ref === void 0 ? void 0 : ref.quantity
                };
            });
            if (availableParentSku.serviceCheckStatus && index > -1) {
                var _installServiceData;
                const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
                const { skuId =""  } = serviceData;
                var _serviceQty;
                selectedItems.push({
                    sku: skuId,
                    quantity: (_serviceQty = availableParentSku.serviceQty) !== null && _serviceQty !== void 0 ? _serviceQty : 1
                });
            }
            if (selectedItems.length) {
                const cartItems = selectedItems.map((item)=>({
                        ...item,
                        brand: brandName
                    }));
                const requiredItemsForAnalytics = upSellData[index].requiredItems;
                const serviceInfo = upSellData[index].installServiceData;
                const installServiceDataAnlytics = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(serviceInfo) ? {
                    ["ProductDescriptionProductShort_s"]: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.description,
                    ["Product_Category"]: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.productCategory,
                    image: "".concat(serviceInfo.swatchUrl).concat(serviceInfo.images, "?$SellModalDesktop$"),
                    unitPrice: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.discountedPrice,
                    customerFacingSKU: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.customerFacingSKU,
                    productTileName: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.name,
                    ["CustomerFacingBrand_s"]: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.customerBrand,
                    availableQuantity: 1,
                    sku_s: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.skuId,
                    productParentImage: "".concat(serviceInfo.swatchUrl).concat(serviceInfo.images, "?$SellModalDesktop$")
                } : {};
                const requiredItemsArray = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(installServiceDataAnlytics) ? [
                    installServiceDataAnlytics,
                    ...requiredItemsForAnalytics
                ] : [
                    ...requiredItemsForAnalytics
                ];
                const productinfo = [];
                const allSelectedProductInfo = requiredItemsArray;
                allSelectedProductInfo.forEach((productItem, childindex)=>{
                    var ref;
                    const matchedItem = (ref = selectedItems.find((selItem)=>productItem.sku_s === selItem.sku)) !== null && ref !== void 0 ? ref : {};
                    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(matchedItem)) {
                        const { quantity: totalQTY = 1  } = matchedItem;
                        productinfo.push({
                            ...productItem,
                            childindex,
                            index,
                            totalQTY
                        });
                    }
                });
                addServiceToCart(cartItems);
                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForADDtoCart */ .J_)(productinfo, availableParentSku.serviceCheckStatus, serviceInfo, persona, availableParentSku.serviceQty, subTotal);
            }
        }
    };
    const getSelectedItemNum = function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { includedItems ={} , serviceCheckStatus =false  } = item;
        let num = 0;
        for(const key in includedItems){
            if (includedItems.hasOwnProperty(key)) {
                var ref;
                if ((ref = includedItems[key]) === null || ref === void 0 ? void 0 : ref.check) num += 1;
            }
        }
        if (serviceCheckStatus) num = num + 1;
        return num;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ref: slickRef,
        ...slickSettings,
        children: upSellData.map((item, upSellDataIndex)=>{
            var ref, ref1;
            const { cartProductData ={} , cartProductData: { name ="" , quantity =1 , sku ="" , customerFacingSKU ="" , unitPrice =0 , currencySign ="$" , image =""  } = {} , installServiceData: { quantity: installQuantity , name: serviceName = "" , description ="" , discountedPrice =0 , price =0 , images ="" , skuId: serviceSku = "" , presetConfigs: imgConfigs = {} , swatchUrl: baseUrl  } = {} , installServiceData ={} , requiredItems =[]  } = item;
            const imgUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_7__/* .getPresetUrl */ .v$)(width, rowCols, baseUrl, images, imgConfigs, true);
            const imgId = image === null || image === void 0 ? void 0 : image.split("/").at(-1);
            const parsedConfigs = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(productPresetConfigs) ? JSON.parse(productPresetConfigs) : {};
            const productImageUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_7__/* .getPresetUrl */ .v$)(width, rowCols, baseUrlImage, imgId, parsedConfigs);
            const subTotal = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(includedItems) ? (ref = includedItems[sku]) === null || ref === void 0 ? void 0 : ref.subTotal : 0;
            const selectedIncludesNum = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(includedItems) ? getSelectedItemNum(includedItems[sku]) : 0;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "upsell-modal__container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                productTitleUpSell: productTitleUpSell,
                                productImageUrl: productImageUrl,
                                customerFacingSKU: customerFacingSKU,
                                name: name,
                                quantity: quantity,
                                unitPrice: unitPrice,
                                currencySign: currencySign,
                                outOfStockTitle: outOfStockTitle,
                                includeTitle: includeTitle,
                                containerClassName: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "right-side",
                                children: !requiredItems.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "title",
                                            children: serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : null
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "description",
                                            children: serviceAvailableDescUpsell
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "installation-services",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "installation-services__left",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__image",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: imgUrl,
                                                                alt: serviceName
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__links",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__learn-more",
                                                                    role: "link",
                                                                    onClick: (e)=>installserviceClickHandler(e, serviceName, cartProductData, upSellDataIndex, item),
                                                                    children: learnAboutUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(learnAboutUpSell) : null
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__price-guard",
                                                                    role: "link",
                                                                    onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, item),
                                                                    children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "installation-services__right",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__right--mobile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__title",
                                                                    children: serviceName
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__price--moblie",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                        discountedPrice: discountedPrice,
                                                                        price: price,
                                                                        currencySign: currencySign
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__description",
                                                            children: description
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__sku",
                                                            children: skuPrependName.toLowerCase() === serviceSku.substring(0, 2).toLowerCase() ? serviceSku : "".concat(skuPrependName ? skuPrependName : "").concat(serviceSku)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__price",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                discountedPrice: discountedPrice,
                                                                price: price,
                                                                currencySign: currencySign
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__add-to-cart",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__quantity-selector",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                        size: "small",
                                                                        value: installQuantity,
                                                                        source: "cart-landing",
                                                                        onChange: (qty, action)=>handleChange(qty, sku, upSellDataIndex, action, installServiceData, item)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "add-to-cart",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                        role: "button",
                                                                        label: "Add To Cart",
                                                                        onClick: ()=>addTocarthandler(item, upSellDataIndex, sku, serviceName, "add to cart", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : null, upSellDataIndex, installServiceData),
                                                                        size: "large",
                                                                        type: "primary",
                                                                        flexible: true
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__tool-tip",
                                                            onMouseOver: ()=>{
                                                                handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                            },
                                                            onFocus: ()=>{
                                                                handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                            },
                                                            onMouseLeave: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                            onBlur: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__tool-tip ".concat(tooltip.buyMoreSaveMore ? "--show" : "--hide"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "installation-services__tool-tip-wrapper",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                                            message: toolTipsDescUpSell
                                                                        })
                                                                    })
                                                                }),
                                                                toolTipsUpSell
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__links--mobile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__learn-more",
                                                                    role: "link",
                                                                    onClick: (e)=>installserviceClickHandler(e, serviceName, cartProductData, upSellDataIndex, item),
                                                                    children: learnAboutUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(learnAboutUpSell) : null
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__price-guard",
                                                                    role: "link",
                                                                    onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, item),
                                                                    children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "installation-services__mobile-landscpae",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mobile-landscpae__add-to-cart",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__quantity-selector",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                size: "small",
                                                                value: installQuantity,
                                                                source: "cart-landing",
                                                                onChange: (qty, action)=>handleChange(qty, sku, upSellDataIndex, action, installServiceData, item)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__button-to-cart",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                role: "button",
                                                                label: "Add To Cart",
                                                                onClick: ()=>addTocarthandler(item, upSellDataIndex, sku, serviceName, "add to cart", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : null, upSellDataIndex),
                                                                size: "large",
                                                                type: "primary",
                                                                flexible: true
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mobile-landscpae__tool-tip",
                                                    onMouseOver: ()=>{
                                                        handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                    },
                                                    onFocus: ()=>{
                                                        handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                    },
                                                    onMouseLeave: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                    onBlur: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                    children: toolTipsUpSell
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mobile-landscpae__links--mobile",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__learn-more",
                                                            role: "link",
                                                            onClick: (e)=>installserviceClickHandler(e, serviceName, cartProductData, upSellDataIndex, item),
                                                            children: learnAboutUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(learnAboutUpSell) : null
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__price-guard",
                                                            role: "link",
                                                            onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, item),
                                                            children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "required-parts-right-side",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "required-item-header",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "required-item-title",
                                                    children: recommendationTitle
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "subtotal-add-to-cart",
                                                    children: [
                                                        subTotal > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "required-item-price",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                currencySign: currencySign,
                                                                price: subTotal
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "add-to-cart",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                role: "button",
                                                                label: "Add to Cart (".concat(selectedIncludesNum, ")"),
                                                                onClick: ()=>addSelectedItem(sku, upSellDataIndex, subTotal),
                                                                size: "large",
                                                                type: "primary",
                                                                flexible: true,
                                                                disabled: !subTotal
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "required-item",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "required-item-list",
                                                children: [
                                                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(installServiceData) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "required-item-install-service",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "required-item-install-service__img",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: imgUrl,
                                                                    alt: serviceName
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "required-item-install-service__title",
                                                                children: serviceName
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "required-item-install-service__sku",
                                                                children: skuPrependName.toLowerCase() === serviceSku.substring(0, 2).toLowerCase() ? serviceSku : "".concat(skuPrependName ? skuPrependName : "").concat(serviceSku)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "required-item-install-service__price-quantity",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "required-item-install-service__price",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                            discountedPrice: discountedPrice,
                                                                            price: price,
                                                                            currencySign: currencySign
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "required-item-install-service__quantity",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                            doNotRequiredAnalyticsData: true,
                                                                            productdata: cartProductData,
                                                                            size: "small",
                                                                            value: installQuantity,
                                                                            source: "cart-landing",
                                                                            onChange: (qty, action)=>handleChange(qty, sku, upSellDataIndex, action, installServiceData, item)
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "required-item-install-service__include",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "include-div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "checkbox",
                                                                                children: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(includedItems) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                                    checked: (ref1 = includedItems[sku]) === null || ref1 === void 0 ? void 0 : ref1.serviceCheckStatus,
                                                                                    onChange: (e)=>checkChangeHandlerForService(e, sku, upSellDataIndex, installServiceData)
                                                                                }) : null
                                                                            }),
                                                                            includeTitle
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "price-gurd-link",
                                                                        role: "link",
                                                                        onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, recommendationTitle ? recommendationTitle : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell), upSellDataIndex, item),
                                                                        children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : null,
                                                    requiredItems.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                                requiredProductItem: item,
                                                                persona: persona,
                                                                currencySign: currencySign,
                                                                parsedConfigs: parsedConfigs,
                                                                rowCols: rowCols,
                                                                baseUrl: baseUrlImage,
                                                                parentSku: sku,
                                                                includedItems: includedItems,
                                                                upSellDataIndex: upSellDataIndex,
                                                                updateRequiredItems: checkChangeHandlerForReqItems,
                                                                recommendationTitle: recommendationTitle,
                                                                quantityChangeHanlder: quantityChangeHanlder,
                                                                includeTitle: includeTitle,
                                                                outOfStockTitle: outOfStockTitle,
                                                                index: index,
                                                                installServiceDataAvailable: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(installServiceData),
                                                                cartProductData: cartProductData
                                                            })
                                                        }, item.sku_s))
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    requiredItems.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "subtotal-add-to-cart--mobile",
                        children: [
                            subTotal > 0 && subTotal != "0.00" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "number-total-mobile",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "selected-mobile",
                                        children: "".concat(selectedTitle, " (").concat(selectedIncludesNum, ")")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "total-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            currencySign: currencySign,
                                            price: subTotal
                                        })
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "add-to-cart-",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    role: "button",
                                    label: "Add To Cart",
                                    onClick: ()=>addSelectedItem(sku, upSellDataIndex),
                                    size: "large",
                                    type: "primary",
                                    flexible: true,
                                    disabled: !subTotal
                                })
                            })
                        ]
                    }) : null
                ]
            }, sku);
        })
    }, "slider-upsell");
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(UpSellInstallServicesCarousalSlick));


/***/ }),

/***/ 95843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UpsellInstallServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./src/store/features/cartSlice.js
var cartSlice = __webpack_require__(64925);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/utils/addTocart.js
var addTocart = __webpack_require__(84003);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/InstallServiceCarousalSlick/index.jsx
var InstallServiceCarousalSlick = __webpack_require__(47010);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/api.js
var api = __webpack_require__(47936);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/utils.js



const getProcessedInstallServiceData = (productServiceData, presetConfigs, swatchUrl, persona, currencySign)=>{
    const productCardProps = {
        presetConfigs: presetConfigs ? JSON.parse(presetConfigs) : "",
        swatchUrl: swatchUrl !== null && swatchUrl !== void 0 ? swatchUrl : "",
        images: image_missing/* default */.Z
    };
    if (!isEmpty_default()(productServiceData)) {
        // get product images
        let imgSrc = "";
        if (productServiceData["productImages.url_ss"]) {
            var ref;
            imgSrc = (ref = productServiceData["productImages.url_ss"][0]) !== null && ref !== void 0 ? ref : "";
        }
        if (imgSrc.length) {
            const imgParts = imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.split("/");
            const imgId = imgParts[imgParts.length - 1];
            productCardProps.images = imgId;
        }
        // get product colors
        if (productServiceData["Color.SKU.Details_ss"]) {
            var ref1;
            const colors = (ref1 = productServiceData["Color.SKU.Details_ss"]) !== null && ref1 !== void 0 ? ref1 : [];
            productCardProps.colors = colors.filter((item)=>{
                const color = item.split("|");
                return color[4] === "false" || Date.parse(color[4]) > Date.now();
            });
        } else {
            productCardProps.colors = [
                ""
            ];
        }
        // get product web features
        if (productServiceData["ProductWebFeatures_s"]) {
            var ref2;
            productCardProps.productFeatures = (ref2 = [
                productServiceData["ProductWebFeatures_s"]
            ]) !== null && ref2 !== void 0 ? ref2 : [];
        } else {
            var ref3;
            productCardProps.productFeatures = (ref3 = productServiceData["ProductWebFeatures_ss"]) !== null && ref3 !== void 0 ? ref3 : [];
        }
        productCardProps.currencySign = currencySign;
        productCardProps.productCategory = get_default()(productServiceData, "Product_Category", "");
        productCardProps.name = get_default()(productServiceData, "productName_s", "");
        productCardProps.brandName = get_default()(productServiceData, "RegionBrandName_s", "");
        productCardProps.description = get_default()(productServiceData, "ProductNarrativeDescription_s", "");
        productCardProps.narrativeDescription = get_default()(productServiceData, "ProductNarrativeDescription_s", "");
        productCardProps.price = get_default()(productServiceData, "priceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountedPrice = get_default()(productServiceData, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountPercent = parseInt(get_default()(productServiceData, "priceList.".concat(persona, ".saleOffer_s"), 0));
        productCardProps.slug = get_default()(productServiceData, "slug_s", "");
        productCardProps.customerBrand = get_default()(productServiceData, "CustomerFacingBrand_s", "");
        productCardProps.skuId = get_default()(productServiceData, "masterSKU_s", "");
        let tempColorDetails = get_default()(productServiceData, "Color.SKU.Details_ss", null);
        if (tempColorDetails) {
            if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                tempColorDetails = tempColorDetails[0];
            }
            productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
        }
        productCardProps.badgeVal = get_default()(productServiceData, "priceList.".concat(persona, ".saleOffer_s"), "");
        productCardProps.globalDiscount = productCardProps.price - get_default()(productServiceData, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
        productCardProps.priceType = "";
    }
    return productCardProps;
};


// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/index.module.scss
var index_module = __webpack_require__(36479);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/localization.js
const getTranslations = (t)=>{
    return {
        search: t("kf.pdp.label.searchBtn")
    };
};

// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/analytics/index.js + 1 modules
var analytics = __webpack_require__(59998);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx + 3 modules
var ProductCardForUpsell = __webpack_require__(8381);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
;// CONCATENATED MODULE: ./src/components/Shared/UpsellInstallServices/index.jsx





















const UpSellInstallServices = (param)=>{
    let { authData ={} , isRequireToLookupFullData =false , upSellProductData =[] , occupyFullWidth =false  } = param;
    const slickRef = (0,react.useRef)(null);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { isAuth , user: { firstName =""  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { utilityLocation =""  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const { consolidatedZipCodes =[]  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { search ="Search"  } = staticText;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [upSellData, setUpSellData] = (0,react.useState)([]);
    const [zipCodeVal, setZipCodeVal] = (0,react.useState)(utilityLocation);
    const [showInput, setShowInput] = (0,react.useState)(utilityLocation ? false : true);
    const [loading, setLoading] = (0,react.useState)(true);
    const [isUpsellDataAvailable, setIsUpsellDatAvailable] = (0,react.useState)(false);
    const [isDataAvailToProceed, setIsDataAvailToProceed] = (0,react.useState)(false);
    const [isSearchClick, setIsSearchClick] = (0,react.useState)(false);
    const persona = (0,helper/* getUserPersona */.shu)();
    (0,react.useEffect)(()=>{
        if (utilityLocation) setZipCodeVal(utilityLocation);
    }, [
        utilityLocation
    ]);
    (0,react.useEffect)(()=>{
        return ()=>{
            delete window.isUpsellAnalaticsLoaded;
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (upSellData.length) {
            window.addEventListener("scroll", handleScroll);
        }
    }, [
        upSellData
    ]);
    const { headerAuthData: { userTitleUpSell ="" , zipLabelUpSell ="" , zipChangeLabelUpSell =""  } = {} , productCard: productCardAuthData = {} , upSellServiceData: { presetConfigsUpSell: presetConfigs = "" , swatchUrlUpSell: swatchUrl = "" , jsonFilePathUpSell ="" , isForPostPurchase =false , recommendationTitle ="" , serviceAvailableTitleUpSell =""  } = {}  } = (0,helper/* getUpSellAuthData */.jGm)(authData, isRequireToLookupFullData);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(cart) && !isForPostPurchase) {
            const { lineItems =[]  } = cart;
            if (lineItems.length) fetchSkusBasedOnLineItems();
            else {
                setIsDataAvailToProceed(false);
                setLoading(false);
            }
        }
    }, [
        cart,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (isForPostPurchase) {
            processWithPostPurchaseData();
        } else {
            if (isRequireToLookupFullData) {
                setIsDataAvailToProceed(false);
                setLoading(false);
            }
        }
    }, [
        isForPostPurchase
    ]);
    const performZipCodeLookUp = async (userZipCodeVal)=>{
        let consolidatedZips = consolidatedZipCodes;
        if (consolidatedZipCodes.length < 1) {
            try {
                const { data: { zipcode =[]  } = {}  } = await (0,api/* getZipCodes */.X_)(jsonFilePathUpSell);
                dispatch((0,genericSlice/* setConsolidatedZipCodes */.J_)(zipcode));
                consolidatedZips = zipcode;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.log(err, "err in fetching consolidated zip code");
            }
        }
        let availableSkuIdsForService = [];
        for (const zipKey of consolidatedZips){
            const key = Object.keys(zipKey)[0];
            for (const zipInnerKey of zipKey[key]){
                const zipcode1 = Object.keys(zipInnerKey)[0];
                if (zipcode1 === userZipCodeVal) {
                    availableSkuIdsForService = zipInnerKey[zipcode1];
                    break;
                }
            }
            if (availableSkuIdsForService.length) break;
        }
        return availableSkuIdsForService;
    };
    const processWithPostPurchaseData = async ()=>{
        if (upSellProductData.length) {
            const { productItems =[] , currency , lwAppName  } = await (0,helper/* getProcessedProductInfoBasedOnLineItems */.N2S)(upSellProductData);
            mapProductDataWithServicesData(productItems, lwAppName, currency);
        }
        return null;
    };
    const fetchSkusBasedOnLineItems = async ()=>{
        (0,helper/* calculateCartData */.DpP)({
            cart: (0,helper/* sanitizeDOMString */.TRt)(cart)
        }, true).then((res)=>{
            const { cartItems , lwAppName , cart: { price: { currency  } = {}  } = {}  } = res;
            mapProductDataWithServicesData(cartItems, lwAppName, currency);
        });
    };
    const mapProductDataWithServicesData = async function() {
        let productItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], lwAppName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        if (!productItems.length) {
            setIsDataAvailToProceed(false);
            return;
        }
        const persona = (0,helper/* getUserPersona */.shu)();
        const productCartItems = productItems.filter((item)=>{
            var ref;
            return !(item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.includes("INSTALL-SERVICE"));
        });
        const installServicesSkus = [];
        productCartItems.forEach((item)=>{
            const { associatedServices =[]  } = item;
            if (associatedServices.length) {
                installServicesSkus.push(...associatedServices);
            }
        });
        const skuIds = Array.from(new Set(installServicesSkus));
        const skusServiceable = await performZipCodeLookUp(zipCodeVal);
        const availableSkusToServe = skusServiceable.filter((value)=>skuIds.includes(value));
        (0,api/* getProductDataFromSkuIds */.fh)(persona, availableSkusToServe, lwAppName).then(async (res)=>{
            let processedInstallServiceData = [];
            if (res === null || res === void 0 ? void 0 : res.data) {
                const rawInstallServiceData = get_default()(res.data, "response.docs", []);
                processedInstallServiceData = rawInstallServiceData.map((product)=>getProcessedInstallServiceData(product, presetConfigs, swatchUrl, persona, currency));
            }
            const productAndServiceData = [];
            productCartItems.forEach((item)=>{
                const { associatedServices =[]  } = item;
                var ref;
                const serviceData = (ref = processedInstallServiceData.find((serviceItem)=>serviceItem.skuId === associatedServices[0])) !== null && ref !== void 0 ? ref : {};
                let installServiceData = {};
                if (!isEmpty_default()(serviceData)) {
                    installServiceData = {
                        ...serviceData,
                        quantity: item.quantity
                    };
                }
                productAndServiceData.push({
                    cartProductData: item,
                    installServiceData
                });
            });
            const parentSkus = productAndServiceData.map((item)=>{
                var ref;
                return item === null || item === void 0 ? void 0 : (ref = item.cartProductData) === null || ref === void 0 ? void 0 : ref.customerFacingSKU;
            });
            const slugAndSkus = productAndServiceData.map((item)=>{
                var ref, ref1, ref2;
                return {
                    cSku: item === null || item === void 0 ? void 0 : (ref = item.cartProductData) === null || ref === void 0 ? void 0 : ref.customerFacingSKU,
                    slug: item === null || item === void 0 ? void 0 : (ref1 = item.cartProductData) === null || ref1 === void 0 ? void 0 : ref1.slug,
                    sku: item === null || item === void 0 ? void 0 : (ref2 = item.cartProductData) === null || ref2 === void 0 ? void 0 : ref2.sku
                };
            });
            const listOfRequiredSkus = [];
            for (const item of slugAndSkus){
                const { cSku ="" , slug ="" , sku =""  } = item !== null && item !== void 0 ? item : {};
                var ref;
                const { data: { response: { docs: requiredItemsSku = []  } = {}  } = {}  } = (ref = await (0,api/* getListOfRequiredSkus */.Q3)(persona, slug, sku, lwAppName)) !== null && ref !== void 0 ? ref : {};
                if (requiredItemsSku.length) {
                    const { CrossSellRecommendationSKUList_ss: requiredSkuList = []  } = requiredItemsSku[0];
                    if (requiredSkuList.length) {
                        listOfRequiredSkus.push({
                            parentSku: cSku,
                            requiredSkus: requiredSkuList
                        });
                    }
                }
            }
            const requiredSkus = listOfRequiredSkus.map((item)=>item.requiredSkus).flat(1);
            var ref1;
            // Executing second API...
            const { data ={}  } = (ref1 = await (0,api/* getProductDataFromSkuIds */.fh)(persona, requiredSkus, lwAppName)) !== null && ref1 !== void 0 ? ref1 : {};
            const skuidString = requiredSkus.join(",");
            if (!isEmpty_default()(data) && skuidString) {
                const { response: { docs: requiredSkusProductData = []  } = {}  } = data;
                var ref2;
                const { data: { results: productInventory = []  } = {}  } = (ref2 = await (0,api/* getProductInventory */.o)(skuidString)) !== null && ref2 !== void 0 ? ref2 : {};
                if (requiredSkusProductData.length) {
                    listOfRequiredSkus.forEach((item)=>{
                        const index = parentSkus.indexOf(item.parentSku);
                        if (index > -1) {
                            const requiredItemsProductData = requiredSkusProductData.filter((productItem)=>{
                                var ref;
                                return (ref = item.requiredSkus) === null || ref === void 0 ? void 0 : ref.includes(productItem.sku_s);
                            });
                            requiredItemsProductData.forEach((requiredProItem, index)=>{
                                var ref;
                                const inventoryObj = (ref = productInventory.find((inventoryItem)=>requiredProItem.sku_s === inventoryItem.sku)) !== null && ref !== void 0 ? ref : {};
                                var ref1;
                                requiredItemsProductData[index].availableQuantity = (ref1 = inventoryObj === null || inventoryObj === void 0 ? void 0 : inventoryObj.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
                            });
                            productAndServiceData[index].requiredItems = requiredItemsProductData;
                        }
                    });
                }
            }
            const filteredProductAndServiceData = productAndServiceData.filter((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.requiredItems) === null || ref === void 0 ? void 0 : ref.length) || !isEmpty_default()(item === null || item === void 0 ? void 0 : item.installServiceData);
            });
            setIsUpsellDatAvailable(filteredProductAndServiceData.length);
            setUpSellData(filteredProductAndServiceData);
            setLoading(false);
            setIsDataAvailToProceed(true);
            setUtilityInfo();
        });
    };
    const handleAddtoCartResponse = (param)=>{
        let { payload  } = param;
        if (payload) {
            dispatch((0,cartSlice/* setCart */.RV)(payload));
        }
    };
    const addServiceToCart = async (items)=>{
        const payload = await (0,addTocart/* addToCartItem */.q)([
            ...items
        ]);
        const body = {
            actions: payload
        };
        dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
            dispatch((0,genericSlice/* showPreviewCart */.z0)());
            handleAddtoCartResponse(res);
        });
    };
    const handleAddToCart = function(item) {
        let qty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        const { installServiceData: { skuId ="" , customerBrand ="" , quantity =1  } = {}  } = item;
        addServiceToCart([
            {
                sku: skuId,
                quantity: qty !== null && qty !== void 0 ? qty : quantity,
                brand: customerBrand
            }
        ]);
    };
    const setUtilityInfo = ()=>{
        if (zipCodeVal) {
            dispatch((0,locationSlice/* setUtilityLocation */.NL)({
                utilityLocation: zipCodeVal
            }));
        }
    };
    const handleZipSerches = function(type) {
        let sI = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setShowInput(!showInput);
        if (showInput) {
            setIsSearchClick(true);
            if (!isEmpty_default()(cart) && !isForPostPurchase) {
                fetchSkusBasedOnLineItems();
            } else {
                processWithPostPurchaseData();
            }
            if (slickRef.current) slickRef.current.slickGoTo(0);
        }
        (0,analytics/* addAnalyticsForheader */.GH)(zipCodeVal, type, recommendationTitle, serviceAvailableTitleUpSell);
    };
    const handleZipChange = (e)=>{
        const { target: { value =""  } = {}  } = e;
        if (value && !constants.NUMERIC_REGX.test(value)) {
            return;
        }
        setZipCodeVal(value);
    };
    const handleScroll = (e)=>{
        var ref;
        const scrollpostion = (ref = document.querySelector(".upsell-modal-header")) === null || ref === void 0 ? void 0 : ref.offsetTop;
        setIsSearchClick(false);
        const yscrollposition = window.scrollY;
        if (yscrollposition >= scrollpostion - 300) {
            if (!window.isUpsellAnalaticsLoaded) {
                const { cartProductData ={} , requiredItems =[] , installServiceData ={}  } = upSellData.length ? upSellData[0] : {};
                const installServiceDataAnlytics = !isEmpty_default()(installServiceData) ? {
                    ["ProductDescriptionProductShort_s"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.narrativeDescription,
                    ["Product_Category"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.productCategory,
                    image: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.productImageUrl,
                    unitPrice: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.discountedPrice,
                    customerFacingSKU: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerFacingSKU,
                    productTileName: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.name,
                    ["CustomerFacingBrand_s"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerBrand,
                    availableQuantity: 1,
                    sku_s: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerFacingSKU,
                    productParentImage: "".concat(installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.swatchUrl).concat(installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.images, "?$SellModalDesktop$")
                } : "";
                const requiredItemsArray = !isEmpty_default()(installServiceDataAnlytics) ? [
                    installServiceDataAnlytics,
                    ...requiredItems
                ] : [
                    ...requiredItems
                ];
                const productDataForAnlytics = {
                    parentProductData: cartProductData,
                    requiredItems: requiredItemsArray
                };
                (0,analytics/* addAnalyticsWhenupsellvisible */.qC)(recommendationTitle, productDataForAnlytics, persona);
                window.isUpsellAnalaticsLoaded = true;
            }
        }
    };
    if (!loading && isDataAvailToProceed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).upsellmodal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "upsell-modal ".concat(isForPostPurchase && !occupyFullWidth ? "upsellmodal-order-history" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "upsell-modal-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "upsell-modal-header__title",
                                children: [
                                    userTitleUpSell,
                                    " ",
                                    firstName
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "upsell-modal-header__rightside",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "upsell-modal-header__rightside__zipcode-msg",
                                        children: zipLabelUpSell
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "rightside-for-mobile",
                                        children: [
                                            !showInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "zipcode-if-available",
                                                children: zipCodeVal
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                id: "zipcode-upsell-modal",
                                                type: "text",
                                                maxLength: 5,
                                                label: "ZIP Code",
                                                value: zipCodeVal,
                                                onChange: handleZipChange
                                            }),
                                            !showInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                tabIndex: "0",
                                                role: "link",
                                                className: "zipcode-change-link",
                                                onClick: ()=>handleZipSerches(zipChangeLabelUpSell, true),
                                                children: zipChangeLabelUpSell
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "zipcode-serach-link",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    role: "button",
                                                    onClick: ()=>handleZipSerches(search),
                                                    children: search
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isUpsellDataAvailable && upSellData.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallServiceCarousalSlick/* default */.Z, {
                        upSellData: upSellData,
                        authData: (0,helper/* getUpSellAuthData */.jGm)(authData, isRequireToLookupFullData),
                        handleAddToCart: handleAddToCart,
                        slickRef: slickRef,
                        addServiceToCart: addServiceToCart,
                        isSearchClick: isSearchClick
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardForUpsell/* default */.Z, {
                        authData: productCardAuthData
                    })
                ]
            })
        });
    }
    return null;
};
/* harmony default export */ var UpsellInstallServices = (/*#__PURE__*/(0,react.memo)(UpSellInstallServices));


/***/ }),

/***/ 36479:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upsellmodal":"UpsellInstallServices_upsellmodal__AKSrg"};

/***/ })

}]);